import React from "react";
import Main from "./components/Main";

function App() {
  const [dice, setDice] = React.useState(allNewDice());
  const [tenzies, setTenzies] = React.useState(false);
  const [startTime, setStartTime] = React.useState(0);
  const [rollNo, setRollNo] = React.useState(0);

  React.useEffect(() => {
    const allHeld = dice.every((die) => die.isHeld);
    const firstValue = dice[0].value;
    const sameValue = dice.every((die) => die.value === firstValue);
    if (allHeld && sameValue) {
      setTenzies(true);
      console.log("You won!");
    }
  }, [dice]);

  React.useEffect(() => {
    let timer;
    if (!tenzies) {
      timer = setInterval(() => {
        setStartTime((prevTime) => prevTime + 1);
      }, [1000]);
      return () => {
        clearInterval(timer);
      };
    }
  }, [tenzies]);

  function allNewDice() {
    let newDice = [];
    for (let i = 0; i < 10; i++) {
      let random = Math.floor(Math.random() * 6);
      newDice.push({ value: random, id: i, isHeld: false });
    }
    return newDice;
  }

  function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${hours}:${minutes}:${secs}`;
  }

  function rollDice() {
    if (tenzies) {
      setDice(allNewDice());
      setTenzies(false);
      setStartTime(0);
      setRollNo(0);
    } else {
      setDice((oldDie) =>
        oldDie.map((die) => ({
          ...die,
          value: die.isHeld ? die.value : Math.floor(Math.random() * 6),
        }))
      );
      setRollNo((prevRoll) => prevRoll + 1);
    }
  }

  function toggleId(id) {
    setDice(
      dice.map((die) => ({
        ...die,
        isHeld: id === die.id ? !die.isHeld : die.isHeld,
      }))
    );
  }

  function resetGame() {
    setDice(allNewDice());
    setTenzies(false);
    setStartTime(0);
    setRollNo(0);
  }

  return (
    <div>
      <Main
        dice={dice}
        handleClick={rollDice}
        toggleId={toggleId}
        tenzies={tenzies}
        startTime={startTime}
        formatTime={formatTime}
        rollNo={rollNo}
        resetGame={resetGame}
      />
    </div>
  );
}
export default App;
